const LangDefaultCardForm = {
	"defaultCardForm.form._title": ["MY TRANSACTIONS", "ប្រតិបត្តិការ​​ខ្ញុំ"],
	"defaultCardForm.copy._storeValue": ["STORED VALUE", "ទឹក​ប្រាក់​ក្នុង​កាត"],
	"defaultCardForm.copy._expiryDate": ["EXPIRY DATE", "កាល​បរិច្ឆេទ​ផុត​កំណត់"],
	"defaultCardForm.form.label._isDefault": ["Set as Default", "កំណត់​ជា​ចម្បង"],
}

export default LangDefaultCardForm



// WEBPACK FOOTER //
// ./src/resources/modules/LangDefaultCardForm.js